import { render, staticRenderFns, recyclableRender, components } from "./clerkcoupon.vue?vue&type=template&id=c9349d74&scoped=true&"
var renderjs
import script from "./clerkcoupon.vue?vue&type=script&lang=js&"
export * from "./clerkcoupon.vue?vue&type=script&lang=js&"
import style0 from "./clerkcoupon.vue?vue&type=style&index=0&id=c9349d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9349d74",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/store/part/clerkcoupon.vue"
export default component.exports